import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/locales/useLocalesQueryKeys.ts
var t = e("locales", { list: () => ["list"] });
//#endregion
export { t as localesQueryKeys };
